'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface Feature {
	number: string
	title: string
	description: string
}

const features: Feature[] = [
	{
		number: '01',
		title: 'Настройка безопасного контура',
		description:
			'Создаём для вашей компании персональное изолированное пространство и настраиваем защищённый канал связи со Сбером.'
	},
	{
		number: '02',
		title: 'Подключение бизнес-карт',
		description:
			'Привязываем ваши карты для выплат к интерфейсу приложения и конфигурируем лимиты для сотрудников.'
	},
	{
		number: '03',
		title: 'Тестирование',
		description:
			'Проводим финальную проверку безопасности шифрования данных и корректности прохождения СМС-кодов при выплатах.'
	},
	{
		number: '04',
		title: 'Передача доступов',
		description:
			'Передаём вам готовый личный кабинет. Сервис сразу доступен для работы кассиров с любого смартфона или планшета.'
	}
]

const ReadySolution: React.FC = () => {
	return (
		<section className={styles.readySolution}>
			<div className={styles.content}>
				<AnimatedSection animation='slideUp'>
					<div className={styles.subtitle}>Готовое решение</div>
					<h2
						className={styles.title}
						dangerouslySetInnerHTML={{ __html: '<span>Запуск «под ключ»</span> — быстрое внедрение за несколько дней' }}
					/>
				</AnimatedSection>
				<AnimatedSection animation='slideUp'>
					<p
						className={styles.description}
						dangerouslySetInnerHTML={{
							__html: 'True.pay B2C — это полностью автономный готовый продукт. Мы разворачиваем и настраиваем систему сами за пару дней.'
						}}
					/>
				</AnimatedSection>

				<div className={styles.features}>
					{features.map((feature, index) => (
						<AnimatedSection key={index} animation='slideUp' className={styles.feature}>
							<div className={styles.featureHeader}>
								<div className={styles.featureNumber}>{feature.number}</div>
								<h3 className={styles.featureTitle}>{feature.title}</h3>
							</div>
							<div
								className={styles.featureDescription}
								dangerouslySetInnerHTML={{ __html: feature.description }}
							/>
						</AnimatedSection>
					))}
				</div>
			</div>
		</section>
	)
}

ReadySolution.displayName = 'ReadySolution'

export default ReadySolution
